import React from 'react'
import './LoadingSpinner.css'
import { usePromiseTracker } from "react-promise-tracker";

/**
 * LoadingSpinner component to display a spinner when called. Divs are important for css
 * usePromiseTracker hook added from react-promise-tracker node package to track if spinner should be applied
*/
const LoadingSpinner = () => {
    const { promiseInProgress } = usePromiseTracker()
    return (
        promiseInProgress && 
        <div className="loading">
            <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
        </div>
    )
}

export default LoadingSpinner